import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { AuthGuard } from '@/components/auth/AuthGuard';

export function AppLayout() {
  return (
    <AuthGuard>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </AuthGuard>
  );
}
